import { Component, inject, OnInit } from '@angular/core';
import { MenuItemsServiceService } from '../../Services/menu-items.service.service';
import { jsPDF } from 'jspdf'; // Import jsPDF
import 'jspdf-autotable'; // Import autoTable for tables
import { CategoryService } from '../../Services/category.service';
import { getAllCategories } from '../../models/Categories Requests DTO/get-categroies.model';
import { MenuItem } from '../../models/add-menuItem-request/menuItem.model';
import * as XLSX from 'xlsx'; // Import XLSX
import { saveAs } from 'file-saver'; // Import file-saver for saving the file
import { NotificationService } from '../../Services/notification.service';

@Component({
  selector: 'app-page-export-menu',
  templateUrl: './page-export-menu.component.html',
  styleUrl: './page-export-menu.component.scss',
})
export class PageExportMenuComponent implements OnInit {

  //Logic Variables
  header: any = null;
  tableData: any[] = [];
  selectedCategory?: getAllCategories;
  categories: { nameEn: string; id: number }[] = [];
  Items!: MenuItem[];

  //Injecting Services
  private menuItemsService = inject(MenuItemsServiceService);
  private categoryService = inject(CategoryService);
  private notificationService = inject(NotificationService);

  ngOnInit(): void {
    this.loadCategories();

    this.menuItemsService.getAllMenuItemsUnPaged().subscribe({
      next: (response) => {
        this.tableData = response;
      },
      error: (err) => {
        this.showErrorMessage();
      }
    });
  }

  //When Category is Selected get the selected category id and name
  onCategorySelect(id: number) {
    //console.log('category id', id);
    this.categoryService.getcategory(id).subscribe({
      next: (response) => {
        this.selectedCategory = response;
        //console.log(response);
      },
      error: (err) => {
        this.showErrorMessage();
      }
    });

    //Fetching Menu Items with Id selectd in the dropdown
    this.menuItemsService.getAllItemByCategoryId(id).subscribe({
      next: (itemsResponse) => {
        this.Items = itemsResponse;
        //console.log(this.Items);
        this.tableData = this.Items;
      },
      error: (err) => {
        this.showErrorMessage();
      }
    });
  }

  //Loading Categories to the dropdown
  loadCategories() {
    this.categoryService.getAllCategories().subscribe({
      next: (data) => {
        //console.log(data); // Log the whole data to see its structure
        this.categories = data.map((category) => ({
          nameEn: category.nameEn, // Adjust 'name' to the actual property name for category names
          id: category.id, // Adjust 'id' to the actual property name for category IDs
        }));
        //console.log('categories En', this.categories); // Log the whole data to see its structure
      },
      error: (err) => {
        this.showErrorMessage();
        //console.error('Error occurred while fetching categories:', err);
        if (err.error) {
          //console.error('Error details:', err.error);
          
        }
      },
    });
  }

  //PDF download
  downloadPDF() {
    const doc = new jsPDF();

    // Define columns and rows
    const columns = [
      'ID',
      'NameTr',
      'DescriptionTr',
      'PriceTr',
      'DiscountedPriceTr',
    ]; // Adjust columns to match your data
    const rows = this.tableData.map((item) => [
      item.id,
      item.nameTr,
      item.DescriptionTr,
      item.PriceTr,
      item.DiscountedPriceTr,
    ]);

    // Generate PDF with table
    doc.text('Menu Items Hungry Birds', 14, 10);
    (doc as any).autoTable({
      head: [columns],
      body: rows,
      startY: 20,
    });

    doc.save('Hungry_Birds.pdf');
    this.showSuccessMessage();
    
  }

  //Excel Download
  exportToExcel(): void {
    // Step 1: Create a worksheet from the table data
    const worksheet = XLSX.utils.json_to_sheet(this.tableData);

    // Step 2: Create a workbook and add the worksheet
    const workbook = {
      Sheets: { 'data': worksheet },
      SheetNames: ['data']
    };

    // Step 3: Write the workbook to a binary file
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    // Step 4: Save the file using file-saver
    const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
    saveAs(blob, 'Hungry_Birds.xlsx');
    this.showSuccessMessage();
  }

  //Notifications
  showSuccessMessage(){
    this.notificationService.showMessage("Successfully Saved", "success");
  }

  showErrorMessage(){
    this.notificationService.showMessage("Failed To Save File", "danger");
  }
}
